// src/lib/cravingWords.js
//
// The craving box's word rule, in one place. CravingBox enforces it on what a
// reader types, the Overheard rows are checked against it before they ship
// (scripts/check-overheard-items.mjs), and the database enforces the same count
// on every Overheard item (overheard_items_min_words,
// 20261009120000_overheard_items.sql). An example shorter than the box's own
// minimum teaches a reader to write something the box refuses.
//
// The count is: trim, then split on runs of whitespace. Keep it that way; the
// database constraint is written to match.

// A borrowed number from the design reference's readiness copy, not a measured
// one (see the MINIMUM LENGTH note in CravingBox.jsx).
export const MIN_CRAVING_WORDS = 20;

export const wordsOf = (s) => {
  const t = (s || '').trim();
  return t ? t.split(/\s+/).filter(Boolean).length : 0;
};
